import React from "react";
import { UserStateContextProvider } from "./user-state-context";

import { ModalContextProvider } from "./modal-context";

export const ContextProviders = ({ children }) => {
  return (
    <UserStateContextProvider>
      <ModalContextProvider>{children}</ModalContextProvider>
    </UserStateContextProvider>
  );
};
